/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint semi: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint block-spacing: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */

export default {
  emailFormat (v) {
    return v.length === 0 || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]+)*$/.test(v)
  },
  phoneFormat (v) {
    return v.length === 0 || /^[0-9-+]*$/.test(v)
  },
  
  usernameRules($t){
    return [
      (v) => !!v || $t('login.vali-username-blank')
    ]
  },
  passwordRules($t){
    return [
      (v) => !!v || $t('login.vali-password-blank')
    ]
  }, 
  passwordReinputRules($t, password){
    return [
      (v) => !!v || $t('login.vali-password-blank'),
      (v) => password === v || 
             $t('user-params.password_reinput_differs'),
    ]
  }, 
  emailRules($t){
    // eslint-disable-next-line
    const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return [
      (v) => !!v || $t('account.vali-email-must'),
      (v) => emailRegEx.test(v) || $t('account.vali-email-format'),
    ]
  },
}



// WEBPACK FOOTER //
// ./src/utils/validate.js